import { Building2 } from 'lucide-react';

const DiningRoomBranchEmpty = () => {
  return (
    <div className="flex min-h-[340px] flex-col items-center justify-center px-8 py-10 text-center">
      <div className="mb-5 rounded-2xl bg-gray-2 p-5 dark:bg-meta-4">
        <Building2 className="h-10 w-10 text-bodydark2" />
      </div>

      <h2 className="text-lg font-semibold text-black dark:text-white">
        No hay sucursales disponibles
      </h2>

      <p className="mt-2 max-w-md text-sm leading-6 text-bodydark2">
        Antes de crear salones para el restaurante, debe registrar al menos
        una sucursal en el sistema.
      </p>
    </div>
  );
};

export default DiningRoomBranchEmpty;